import 'zone.js';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

// Metronic vendors.bundle.js supplies window.$ (jQuery 3.2.1 + plugins).
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
